
const styles = {
    listItem: {
        border: "solid 1px lightgray",
        padding: 10,
        borderRadius: 5,
        marginBottom: 5
    } as React.CSSProperties,
};
export default styles;